var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPieChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m240.917 511.365v-212.993l-133.698 165.291c39.239 28.359 85.272 44.872 133.698 47.702z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m270.895 270.996v240.369c62.279-3.638 120.633-29.882 165.67-74.854 45.047-44.982 71.352-103.277 74.997-165.515z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m405.64 142.961h37.441v98.057h-37.441z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.346 75.499c-48.588 48.564-75.346 112.67-75.346 180.508s26.758 131.944 75.346 180.508c2.82 2.818 5.697 5.556 8.62 8.226l156.951-194.039v-250.067c-62.299 3.649-120.593 29.908-165.571 74.864z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m270.895 113.182h37.348v127.836h-37.348z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m338.221 41.048h37.441v199.971h-37.441z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m473.06 183.042h38.94v57.976h-38.94z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChart);
export default __webpack_public_path__ + "static/media/pie-chart.6739e6c99451dbdc294b9a7253ffbb2f.svg";
export { ForwardRef as ReactComponent };